const dict = {
    "a" : {
        "interjection" : "ah, ha, uh, oh, ooh, aw, well (emotion word)"
    },
    "akesi" : {
        "noun" : "non-cute animal, reptile, amphibian"
    },
    "ala" : {
        "interjection" : "no!",
        "modifier" : "no, not, none, un-",
        "noun" : "nothing, negation, zero"
    },
    "alasa" : {
        "verb_transitive" : "gather, hunt"
    },
    "ale" : {
        "modifier" : "all, every, complete, whole",
        "noun" : "everything, anything, life, the universe"
    },
    "anpa" : {
        "modifier" : "low, lower, bottom, down",
        "noun" : "bottom, lower part, under, below, floor, beneath"
    },
    "ante" : {
        "conjunction" : "otherwise, or else",
        "modifier" : "different",
        "noun" : "difference",
        "verb_transitive" : "change, alter, modify"
    },
    "anu" : {
        "conjunction" : "or"
    },
    "awen" : {
        "modifier" : "remaining, stationary, permanent, sedentary",
        "verb_intransitive" : "stay, wait, remain",
        "verb_transitive" : "keep"
    },
    "e" : {
        "separator" : "(introduces a direct object)"
    },
    "en" : {
        "conjunction" : "and (used to coordinate head nouns)"
    },
    "esun" : {
        "noun" : "market, shop"
    },
    "ijo" : {
        "modifier" : "of something",
        "noun" : "thing, something, stuff, anything, object",
        "verb_transitive" : "objectify"
    },
    "ike" : {
        "interjection" : "oh dear! woe! alas!",
        "modifier" : "bad, negative, wrong, evil, overly complex, (figuratively) unhealthy",
        "noun" : "negativity, badness, evil",
        "verb_intransitive" : "to be bad, to suck",
        "verb_transitive" : "be bad, to make bad, to worsen, to have a negative effect upon"
    },
    "ilo" : {
        "noun" : "tool, device, machine, thing used for a specific purpose"
    },
    "insa" : {
        "modifier" : "inner, internal",
        "noun" : "inside, inner world, centre, stomach"
    },
    "jaki" : {
        "interjection" : "ew! yuck!",
        "modifier" : "dirty, gross, filthy",
        "noun" : "dirt, pollution, garbage, filth",
        "verb_transitive" : "pollute, dirty"
    },
    "jan" : {
        "modifier" : "human, somebody's, personal, of people",
        "noun" : "person, people, human, being, somebody, anybody",
        "verb_transitive" : "personify, humanize, personalize"
    },
    "jelo" : {
        "modifier" : "yellow, light green"
    },
    "jo" : {
        "compound_verb" : "receive, get, take, obtain",
        "noun" : "having",
        "verb_transitive" : "have, contain"
    },
    "kala" : {
        "noun" : "fish, sea creature"
    },
    "kalama" : {
        "compound_verb" : "",
        "modifier" : "coming, future",
        "noun" : "event, happening, chance, arrival, beginning",
        "verb_intransitive" : "come, become, arrive, happen, pursue actions to arrive to (a certain state), manage to, start to",
        "verb_transitive" : "bring about, summon"
    },
    "kasi" : {
        "noun" : "plant, leaf, herb, tree, wood"
    },
    "ken" : {
        "cont" : "it is possible that",
        "noun" : "possibility, ability, power to do things, permission",
        "verb_intransitive" : "can, is able to, is allowed to, may, is possible",
        "verb_transitive" : "make possible, enable, allow, permit"
    },
    "kepeken" : {
        "quasipreposition" : "with",
        "verb_transitive" : "use"
    },
    "kijetesantakalu" : {
        "noun" : "racoon, any animal from the Procyonidae family such as raccoons coatis kinkajous olingos ringtails and cacomistles"
    },
    "kili" : {
        "noun" : "fruit, pulpy vegetable, mushroom"
    },
    "kin" : {
        "modifier" : "also, too, even, indeed (emphasizes the word(s) before it)"
    },
    "kipisi" : {
        "verb_intransitive" : "cut, split, slice",
        "verb_transitive" : "cut, split, slice"
    },
    "kiwen" : {
        "modifier" : "hard, solid, stone-like, made of stone or metal",
        "noun" : "rock, hard thing, stone, metal, mineral, clay"
    },
    "ko" : {
        "noun" : "semi-solid or squishy substance, e.g. paste, powder, gum"
    },
    "kon" : {
        "modifier" : "air-like, ethereal, gaseous",
        "noun" : "air, wind, smell, soul"
    },
    "kule" : {
        "modifier" : "colourful",
        "noun" : "colour, paint",
        "verb_transitive" : "colour, paint"
    },
    "kulupu" : {
        "modifier" : "communal, shared, public, of the society",
        "noun" : "group, community, society, company, people"
    },
    "kute" : {
        "modifier" : "auditory, hearing",
        "verb_transitive" : "listen, hear"
    },
    "la" : {
        "separator" : "(between adverb or phrase of context and sentence)"
    },
    "lape" : {
        "modifier" : "sleeping, of sleep",
        "noun" : "sleep, rest",
        "verb_transitive": "sleep, rest"
    },
    "laso" : {
        "modifier" : "blue, blue-green"
    },
    "lawa" : {
        "modifier" : "main, leading, in charge",
        "noun" : "head, mind",
        "verb_transitive" : "lead, control, rule, steer"
    },
    "len" : {
        "noun" : "clothing, cloth, fabric"
    },
    "lete" : {
        "modifier" : "cold, uncooked",
        "noun" : "cold",
        "verb_transitive" : "cool down, chill"
    },
    "li" : {
        "separator" : "\"(between any subject except mi and sina and its verb; also used to introduce a new verb for the same subject)\""
    },
    "lili" : {
        "modifier" : "small, little, young, a bit, short, few, less",
        "verb_transitive" : "reduce, shorten, shrink, lessen"
    },
    "linja" : {
        "noun" : "long, very thin, floppy thing, e.g. string, rope, hair, thread, cord, chain"
    },
    "lipu" : {
        "noun" : "flat and bendable thing, e.g. paper, card, ticket"
    },
    "loje" : {
        "modifier" : "red"
    },
    "lon" : {
        "quasipreposition" : "be (located) in/at/on",
        "verb_intransitive" : "be there, be present, be real/true, exist, be awake"
    },
    "luka" : {
        "noun" : "hand, arm"
    },
    "lukin" : {
        "modifier" : "visual(ly)",
        "verb_intransitive" : "look, watch out, pay attention",
        "verb_transitive" : "see, look at, watch, read"
    },
    "lupa" : {
        "noun" : "hole, orifice, window, door"
    },
    "ma" : {
        "noun" : "land, earth, country, (outdoor) area"
    },
    "mama" : {
        "modifier" : "of the parent, parental, maternal, fatherly",
        "noun" : "parent, mother, father"
    },
    "mani" : {
        "noun" : "money, material wealth, currency, dollar, capital"
    },
    "meli" : {
        "modifier" : "female, feminine, womanly",
        "noun" : "woman, female, girl, wife, girlfriend"
    },
    "mi" : {
        "modifier" : "my, our",
        "noun" : "I, we"
    },
    "mije" : {
        "modifier" : "male, masculine, manly",
        "noun" : "man, male, boy, husband, boyfriend"
    },
    "moku" : {
        "noun" : "food, meal",
        "verb_transitive" : "eat, drink, swallow, ingest, consume"
    },
    "moli" : {
        "modifier" : "dead, deadly, fatal",
        "noun" : "death",
        "verb_intransitive" : "die, be dead",
        "verb_transitive" : "kill"
    },
    "monsi" : {
        "modifier" : "back, rear",
        "noun" : "back, rear end, butt, behind"
    },
    "mu" : {
        "interjection" : "woof! meow! moo! etc. (cute animal noise)"
    },
    "mun" : {
        "modifier" : "lunar",
        "noun" : "moon"
    },
    "musi" : {
        "modifier" : "artful, fun, recreational",
        "noun" : "fun, playing, game, recreation, art, entertainment",
        "verb_intransitive" : "play, have fun",
        "verb_transitive" : "amuse, entertain"
    },
    "mute" : {
        "modifier" : "many, very, much, several, a lot, abundant, numerous, more",
        "noun" : "amount, quantity",
        "verb_transitive" : "make many or much"
    },
    "namako" : {
        "noun" : "food additive, accessory, something extra",
        "verb_transitive" : "season, embellish, stimulate"
    },
    "nanpa" : {
        "noun" : "number",
        "special" : "-th (ordinal numbers)"
    },
    "nasa" : {
        "modifier" : "silly, crazy, foolish, drunk, strange, stupid, weird",
        "verb_transitive" : "drive crazy, make weird"
    },
    "nasin" : {
        "noun" : "way, manner, custom, road, path, doctrine, system, method"
    },
    "nena" : {
        "noun" : "bump, nose, hill, mountain, button"
    },
    "ni" : {
        "modifier" : "this, that"
    },
    "nimi" : {
        "noun" : "word, name"
    },
    "noka" : {
        "noun" : "leg, foot"
    },
    "o" : {
        "interjection" : "hey! (calling somebody's attention)",
        "separator" : "O (vocative or imperative)"
    },
    "oko" : {
        "noun" : "eye"
    },
    "olin" : {
        "modifier" : "love",
        "noun" : "love",
        "verb_transitive" : "love"
    },
    "ona" : {
        "modifier" : "their, her, his, its",
        "noun" : "they, she, he, it"
    },
    "open" : {
        "verb_transitive" : "open, turn on"
    },
    "pakala" : {
        "interjection" : "damn! fuck!",
        "noun" : "blunder, accident, mistake, destruction, damage, breaking",
        "verb_intransitive" : "screw up, fall apart, break",
        "verb_transitive" : "screw up, fuck up, botch, ruin, break, hurt, injure, damage, spoil, ruin"
    },
    "pali" : {
        "modifier" : "active, work-related, operating, working",
        "noun" : "activity, work, deed, project",
        "verb_intransitive" : "act, work, function",
        "verb_transitive" : "do, make, build, create"
    },
    "palisa" : {
        "noun" : "long, mostly hard object, e.g. rod, stick, branch"
    },
    "pan" : {
        "noun" : "grain, cereal"
    },
    "pana" : {
        "noun" : "giving, transfer, exchange",
        "verb_transitive" : "give, put, send, place, release, emit, cause"
    },
    "pi" : {
        "separator" : "of, belonging to"
    },
    "pilin" : {
        "noun" : "feelings, emotion, heart",
        "verb_intransitive" : "feel",
        "verb_transitive" : "feel, think, sense, touch"
    },
    "pimeja" : {
        "modifier" : "black, dark",
        "noun" : "darkness, shadows",
        "verb_transitive" : "darken"
    },
    "pini" : {
        "modifier" : "completed, finished, past, done, ago",
        "noun" : "end, tip",
        "verb_transitive" : "finish, close, end, turn off"
    },
    "pipi" : {
        "noun" : "bug, insect, spider"
    },
    "poka" : {
        "modifier" : "neighbouring",
        "noun" : "side, hip, next to",
        "quasipreposition" : "in the accompaniment of, with"
    },
    "poki" : {
        "noun" : "container, box, bowl, cup, glass"
    },
    "pona" : {
        "interjection" : "great! good! thanks! OK! cool! yay!",
        "modifier" : "good, simple, positive, nice, correct, right",
        "noun" : "good, simplicity, positivity",
        "verb_intransitive": "be good",
        "verb_transitive" : "improve, fix, repair, make good"
    },
    "pu" : {
        "noun": "buying and interacting with the official Toki Pona book",
        "verb_transitive": "apply the official Toki Pona book",
        "verb_intransitive": "buy or interact with the official Toki Pona book"
    },
    "sama" : {
        "modifier" : "same, similar, equal, of equal status or position",
        "quasipreposition" : "like, as, seem"
    },
    "seli" : {
        "modifier" : "hot, warm, cooked",
        "noun" : "fire, warmth, heat",
        "verb_transitive" : "heat, warm up, cook"
    },
    "selo" : {
        "noun" : "outside, surface, skin, shell, bark, shape, peel"
    },
    "seme" : {
        "special" : "what, which, wh- (question word)"
    },
    "sewi" : {
        "modifier" : "superior, elevated, religious, formal",
        "noun" : "high, up, above, top, over, on"
    },
    "sijelo" : {
        "noun" : "body, physical state"
    },
    "sike" : {
        "modifier" : "round, cyclical",
        "noun" : "circle, wheel, sphere, ball, cycle"
    },
    "sin" : {
        "modifier" : "new, fresh, another, more",
        "verb_transitive" : "renew, renovate, freshen"
    },
    "sina" : {
        "modifier" : "your",
        "noun" : "you"
    },
    "sinpin" : {
        "noun" : "front, chest, torso, face, wall"
    },
    "sitelen" : {
        "noun" : "picture, image",
        "verb_transitive" : "draw, write"
    },
    "sona" : {
        "compound_verb" : "learn, study",
        "noun" : "knowledge, wisdom, intelligence, understanding",
        "verb_intransitive" : "know, understand",
        "verb_transitive" : "know, understand, know how to"
    },
    "soweli" : {
        "noun" : "animal, especially land mammal, lovable animal"
    },
    "suli" : {
        "modifier" : "big, tall, long, adult, important",
        "noun" : "size",
        "verb_transitive" : "enlarge, lengthen"
    },
    "suno" : {
        "noun" : "sun, light"
    },
    "supa" : {
        "noun" : "horizontal surface, e.g furniture, table, chair, pillow, floor"
    },
    "suwi" : {
        "modifier" : "sweet, cute",
        "noun" : "candy, sweet food",
        "verb_transitive" : "sweeten"
    },
    "tan" : {
        "noun" : "origin, cause",
        "quasipreposition" : "from, by, because of, since"
    },
    "taso" : {
        "conjunction" : "but",
        "modifier" : "only, sole"
    },
    "tawa" : {
        "modifier" : "moving, mobile",
        "noun" : "movement, transportation",
        "quasipreposition" : "to, in order to, towards, for, until",
        "verb_intransitive" : "go to, walk, travel, move, leave",
        "verb_transitive" : "move, displace"
    },
    "telo" : {
        "modifier": "liquid, watery, wet",
        "noun" : "water, liquid, juice, sauce",
        "verb_transitive" : "water, wash with water"
    },
    "tenpo" : {
        "noun" : "time, period of time, moment, duration, situation"
    },
    "toki" : {
        "interjection" : "hello! hi!",
        "modifier" : "talking, verbal",
        "noun" : "language, talking, speech, communication",
        "verb_intransitive" : "talk, chat, communicate",
        "verb_transitive" : "say"
    },
    "tomo" : {
        "modifier" : "urban, domestic, household",
        "noun" : "indoor constructed space, e.g. house, home, room, building"
    },
    "tu" : {
        "modifier" : "two",
        "noun" : "duo, pair",
        "verb_transitive" : "double, separate/cut/divide in two"
    },
    "unpa" : {
        "modifier" : "erotic, sexual",
        "noun" : "sex, sexuality",
        "verb_intransitive" : "have sex",
        "verb_transitive" : "have sex with, sleep with, fuck"
    },
    "uta" : {
        "modifier" : "oral",
        "noun" : "mouth"
    },
    "utala" : {
        "noun" : "conflict, disharmony, competition, fight, war, battle, attack, blow, argument, physical or verbal violence",
        "verb_transitive" : "hit, strike, attack, compete against"
    },
    "walo" : {
        "modifier" : "white, light (colour)",
        "noun" : "white thing or part, whiteness, lightness"
    },
    "wan" : {
        "modifier" : "one, a",
        "noun" : "unit, element, particle, part, piece",
        "verb_transitive" : "unite, make one"
    },
    "waso" : {
        "noun" : "bird, winged animal"
    },
    "wawa" : {
        "modifier" : "energetic, strong, fierce, intense, sure, confident",
        "noun" : "energy, strength, power",
        "verb_transitive" : "strengthen, energize, empower"
    },
    "weka" : {
        "modifier" : "away, absent, missing",
        "noun" : "absence",
        "verb_transitive" : "throw away, remove, get rid of"
    },
    "wile" : {
        "modifier" : "necessary",
        "noun" : "desire, need, will",
        "verb_transitive" : "to want, need, wish, have to, must, will, should"
    }
}

const NOUN = 0
const VERB = 1
const OBJECT = 2


let TPEnglish = {

    getDict() {
        return dict;
    },

    getTextTranslation(text) {

        let result_translated = {
            sentences: []
        }

        let analysis = this.getTextAnalysis(text);

        for (let i = 0; i < analysis.sentences.length; i++) {
            result_translated.sentences.push(this.getSentenceTranslation(analysis.sentences[i]));
        }

        return {
            analysis: analysis,
            translation: result_translated
        };

    },

    getSentenceTranslation(sdata) {

        if (!sdata.is_text) {
            return {
                is_text: false,
                content: sdata.content
            }
        }

        let engresult = {
            is_text: true,
            has_verb: false,
            has_obj: false,
            subject: [],
            verb: [],
            object: []
        };

        //PARSE SUBJECT

        engresult.subject.push(this.get_noun(sdata.subject[0]));

        for (let i = 1; i < sdata.subject.length; i++) {
            engresult.subject.unshift(this.get_mod(sdata.subject[i]));
        }

        //PARSE VERB

        if (sdata.has_verb) {
            engresult.has_verb = true;

            if (sdata.has_object) {
                engresult.verb.push(this.get_verbt(sdata.verb[0]));
            } else {
                engresult.verb.push(this.get_verb(sdata.verb[0]));
            }

            for (let i = 1; i < sdata.verb.length; i++) {
                engresult.verb.push(this.get_mod(sdata.verb[i]));
            }

        }

        //PARSE OBJECT

        if (sdata.has_object) {
            engresult.has_object = true;

            engresult.object.push(this.get_noun(sdata.object[0]));

            for (let i = 1; i < sdata.object.length; i++) {
                engresult.object.unshift(this.get_mod(sdata.object[i]));
            }

        }

        return engresult;

    },

    getTextAnalysis(text) {

        let result = {
            sentences: []
        };

        if (text.length === 0) return result;

        let text_sentences = [];

        let start = 0;
        let in_sentence = text[0].match(/[A-Za-z\s]/);
        for (let i = 0; i < text.length + 1; i++) {

            if (i === text.length) {
                if (in_sentence) {
                    text_sentences.push(text.substr(start, i - start));
                } else if (!in_sentence) {
                    text_sentences.push(text.substr(start, i - start));
                }
                break;
            }

            if (in_sentence && text[i].match(/[^A-Za-z\s]/)) {
                in_sentence = false;
                text_sentences.push(text.substr(start, i-start));
                start = i;
            } else if (!in_sentence && text[i].match(/[A-Za-z\s]/)) {
                in_sentence = true;
                text_sentences.push(text.substr(start, i-start));
                start = i;
            }
        }

        for (let i = 0; i < text_sentences.length; i++) {
            if (text_sentences[i].match(/[A-Za-z\s]/)) {
                result.sentences.push(this.getSentenceAnalysis(text_sentences[i]));
            } else {
                result.sentences.push( {is_text: false, content: text_sentences[i]} );
            }
        }

        return result;
    },

    getSentenceAnalysis(sentence) {

        let sresult = {
            is_text: true,
            has_verb: false,
            has_obj: false,
            subject: [],
            verb: [],
            object: []
        };

        let state = NOUN;

        let words = sentence.split(/[^A-Za-z]/)

        for (let i = 0; i < words.length; i++) {

            let word = words[i];

            if (!word.match(/[A-Za-z]/)) continue;
            if (!this.find_word(word)) continue;

            switch (word) {
                case "li":
                    state = VERB;
                    break;
                case "e":
                    state = OBJECT;
                    break;
                default:
                    if (state === NOUN) {
                        sresult.subject.push(word);
                        if (word === "mi" || word === "sina") {
                            state = VERB;
                        }
                    } else if (state === VERB) {
                        sresult.verb.push(word);
                        sresult.has_verb = true;
                    } else if (state === OBJECT) {
                        sresult.object.push(word);
                        sresult.has_object = true;
                    }
                    break;
            }
        }

        return sresult;
    },

    find_word(word) {
        let word_data = dict[word];
        if (word_data != null) {
            return word_data;
        }
        console.log("Word not found: " + word);
        return false;
    },

    get_noun(word) {
        let word_data = this.find_word(word)
        if (word_data) {
            if (word_data.noun != null) {
                let nouns = word_data.noun.split(", ");
                return nouns[0];
            } else {
                console.log("Noun not found for word: " + word);
            }
        }
    },

    get_mod(word) {
        let word_data = this.find_word(word)
        if (word_data) {
            if (word_data.modifier != null) {
                let modifiers = word_data.modifier.split(", ");
                return modifiers[0];
            } else {
                console.log("Modifier not found for word: " + word);
            }
        }
    },

    get_verb(word, try_other = true) {
        let word_data = this.find_word(word)
        if (word_data) {
            if (word_data.verb_intransitive != null) {
                let verbs = word_data.verb_intransitive.split(", ");
                return verbs[0];
            } else {
                console.log("Verb not found for word: " + word);
                if (try_other) {
                    return this.get_verbt(word, false);
                }
            }
        }
    },

    get_verbt(word, try_other = true) {
        let word_data = this.find_word(word)
        if (word_data) {
            if (word_data.verb_transitive != null) {
                let verbs = word_data.verb_transitive.split(", ");
                return verbs[0];
            } else {
                console.log("Transitive verb not found for word: " + word);
                if (try_other) {
                    return this.get_verb(word, false);
                }
            }
        }
    }
}

export default TPEnglish;